import React from 'react';
import { Trash2, Check, X } from 'lucide-react';
import { CNFUtils } from '../utils/CNFUtils';

const ClauseCard = ({ clause, index, assignment, onDelete }) => {
  const isTrue = CNFUtils.evaluateClause(clause.literals, assignment);
  return (
    <div className={`border-2 rounded-lg p-4 transition-all ${isTrue ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'}`}>
      <div className="flex justify-between items-start mb-2">
        <span className="text-sm font-semibold text-gray-600">Clause {index + 1}</span>
        <button onClick={() => onDelete(index)} className="text-red-500 hover:text-red-700"><Trash2 size={16} /></button>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        {clause.literals.map((lit, idx) => {
          const value = assignment[lit.variable];
          const litValue = lit.negated ? !value : value;
          return (
            <React.Fragment key={idx}>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${litValue ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
                {lit.negated && '¬'}{lit.variable}
              </span>
              {idx < clause.literals.length - 1 && <span className="text-gray-400 font-bold">∨</span>}
            </React.Fragment>
          );
        })}
        <div className="ml-auto">{isTrue ? <Check className="text-green-600" size={20} /> : <X className="text-red-600" size={20} />}</div>
      </div>
    </div>
  );
};

export default ClauseCard;